import * as animationsAndTransitionsConfigurationValues from "../../../configuration/animations-and-transitions-configuration.json";
import * as answersConfigurationValues from "../../../configuration/answers-configuration.json";
import * as brandingConfigurationValues from "../../../configuration/branding-configuration.json";
import * as colorsConfigurationValues from "../../../configuration/colors-configuration.json";
import * as customCSSConfigurationValues from "../../../configuration/custom-css-configuration.json";
import * as fontsConfigurationValues from "../../../configuration/fonts-configuration.json";
import * as pdfConfigurationValues from "../../../configuration/pdf-configuration.json";
import * as priceConfigurationValues from "../../../configuration/price-configuration.json";
import * as productButtonConfigurationValues from "../../../configuration/product-button-configuration.json";
import * as productRatingConfigurationValues from "../../../configuration/product-rating-configuration.json";
import * as questionConfigurationValues from "../../../configuration/question-configuration.json";
import * as recommendationConfigurationValues from "../../../configuration/recommendation-configuration.json";
import * as standardTextsConfigurationValues from "../../../configuration/standard-texts-configuration.json";
import * as topProductConfigurationValues from "../../../configuration/top-product-configuration.json";
import * as searchbarConfigurationValues from "../../../configuration/searchbar-configuration.json";

export enum ConfigurationValues {
    Answers = "Answers",
    Branding = "Branding",
    Colors = "Colors",
    Fonts = "Fonts",
    Question = "Question",
    TopProduct = "TopProduct",
    Recommendation = "Recommendation",
    StandardTexts = "StandardTexts",
    CustomCSS = "CustomCSS",
    ProductButtonSettings = "ProductButtonSettings",
    ProductRating = "ProductRating",
    Price = "Price",
    Pdf = "Pdf",
    AnimationsAndTransitions = "AnimationsAndTransitions",
    Searchbar = "Searchbar",
}

export class ValuesConfigurationProvider {
    public provide(configurationValues: string): any {
        switch (configurationValues) {
            case ConfigurationValues.Answers:
                return answersConfigurationValues.answersConfiguration;
            case ConfigurationValues.Branding:
                return brandingConfigurationValues.branding;
            case ConfigurationValues.Colors:
                return colorsConfigurationValues.colors;
            case ConfigurationValues.Fonts:
                return fontsConfigurationValues.fonts;
            case ConfigurationValues.Question:
                return questionConfigurationValues.questionConfiguration;
            case ConfigurationValues.TopProduct:
                return topProductConfigurationValues.topProductSettings;
            case ConfigurationValues.Recommendation:
                return recommendationConfigurationValues.recommendationSettings;
            case ConfigurationValues.StandardTexts:
                return standardTextsConfigurationValues.standardTexts;
            case ConfigurationValues.CustomCSS:
                return customCSSConfigurationValues.customCSSConfiguration;
            case ConfigurationValues.ProductButtonSettings:
                return productButtonConfigurationValues.productButtonConfiguration;
            case ConfigurationValues.Price:
                return priceConfigurationValues.price;
            case ConfigurationValues.ProductRating:
                return productRatingConfigurationValues.productRating;
            case ConfigurationValues.Pdf:
                return pdfConfigurationValues.pdfConfiguration;
            case ConfigurationValues.AnimationsAndTransitions:
                return animationsAndTransitionsConfigurationValues.animationsAndTransitionsConfiguration;
            case ConfigurationValues.Searchbar:
                return searchbarConfigurationValues.searchbarConfiguration;
            default:
                break;
        }
        return {};
    }
}

export {
    answersConfigurationValues,
    brandingConfigurationValues,
    colorsConfigurationValues,
    fontsConfigurationValues,
    questionConfigurationValues,
    topProductConfigurationValues,
    recommendationConfigurationValues,
    standardTextsConfigurationValues,
    customCSSConfigurationValues,
    productButtonConfigurationValues,
    productRatingConfigurationValues,
    priceConfigurationValues,
    pdfConfigurationValues,
    animationsAndTransitionsConfigurationValues,
    searchbarConfigurationValues
};
